import React, { useState, useEffect, useRef, Suspense } from "react";
import { jsPDF } from "jspdf";

import {
  I2cButton,
  I2cIcon,
  I2cProgressBar,
  I2cAvatar,
  I2cDropdown,
  I2cBadge,
  I2cMenu,
  I2cMenuItem,
  I2cAvatarGroup,
  I2cDialog,
  I2cFormatDate,
} from "@webcomponents/i2cwebcomponents/dist/react";
import "../../Utils/shared-styles/Authentication.scss";
import { useMutation, useQueryClient, useQuery } from "react-query";
import ConfirmaionModal from "../../Components/ConfirmationModal/ConfirmationModal";
import "./SalesRequest.scss";
import { CarouselProvider, Slider, Slide } from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import { useNavigate } from "react-router-dom";
import { getFormatedDate } from "../../Utils/stringUtls";
import { extractKeyValues } from "../Users/UserProjects";
import { getBadgeVariant } from "../../Utils/stringUtls";
import SalesService from "../../Services/SalesService";
import UserManagmentService from "../../Services/UsermanagmentService";
import AssignProjectUsers from "./AssignProjectUsers";
import FormsService from "../../Services/FormsAssignmentService";
import { OverlayLoader } from "../../Components/Loader/Loader";
import {
  I2cFileUpload,
  I2cSignature,
} from "@webcomponents/i2cwebcomponents/dist/react";
import AvatarGroup from "./AvatarGroup";
import ErrorBoundary from "./ErrorBoundary";

import { consumerChannel, credit_consumerChannel, merchantChannel, credit_merchantChannel, otherChannel, credit_otherChannel } from './stringUtils';

export const statuses = [
  "Draft",
  "New Request",
  "New",
  "Signed Off",
  "Cancelled",
  "Completed",
];
const LazyComponent = React.lazy(() => import("./AvatarGroup"));
const SingleSalePreview = ({ sale, queryKey, onDeleteSuccess }) => {
  const [openUserModal, setOpenUserModal] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [showProducts, setShowProducts] = useState(false);
  const [showConfirmatonModal, setShowConfirmatonModal] = useState(false);
  const [deleteableUser, setDeleteableUser] = useState();
  const [viewportWidth, setViewportWidth] = useState();
  const [showAlert, setShowAlert] = useState(null);
  const [loading, setLoading] = useState(false);
  const queryClient = useQueryClient();
  const [visibleSlides, setVisibleSlides] = useState(3);
  const table = useRef(null);
  const tableExternal = useRef(null);
  const navigate = useNavigate();

  const keysToExtract = [
    "pd_client_name",
    "pi_program_type",
    "pi_program_name",
    "pd_region",
    "pd_team_avail",
    "pd_go_live",
    "ci_businessName",
    "ci_companyPhone",
    "cp_fi_fi_name",
    "cp_fi_phone_num",
  ];

  const data = JSON.parse(sale.form_data);

  const channelsText = sale?.form_type === 1
    ? {
      consumer: consumerChannel,
    }
    : {
      consumer: credit_consumerChannel,
    };
  const getLabel = (channelArray, value) => {
    const channelItem = channelArray.find(item => item.value === Number(value));
    return channelItem ? channelItem.label : '';
  };
  const extractedData = extractKeyValues(data, keysToExtract);

  const saleData = {};
  const { form_id: formId } = sale;
  const badgeVariant = getBadgeVariant(sale.form_status_id);
  // Iterate over each object in the array
  extractedData.forEach((obj) => {
    // Get the key and value from each object
    const [key, value] = Object.entries(obj)[0];
    // Add the key-value pair to the merged object
    saleData[key] = value;
  });
  // const assignedAvatars = Object.entries(JSON.parse(sale.assigned_avatars));
  const assignedAvatars = sale.assigned_avatars;
  const saleDeleteMutation = useMutation(
    (projectID) => SalesService.deleteForm(projectID),
    {
      onSuccess: () => {
        //  Optional: Perform any actions after successful deletion
        //   refetchUsers();
        queryClient.invalidateQueries(queryKey);
        setShowConfirmatonModal(false);
        setShowAlert({
          open: true,
          success: true,
          message: "Record has been deleted successfully!",
        });
        onDeleteSuccess();
      },
      onError: (e) => {
        setShowConfirmatonModal(false);
        // setShowAlert({
        // 	open: true,
        // 	success: false,
        // 	message: "Something went wrong",
        // });
      },
    },
  );
  // Function to fetch products by formId
  const fetchProducts = async (formId) => {
    try {
      const res = await SalesService.fetchProductsWithFormID(formId);
      return res.data.products; // Assuming the response structure has data here
    } catch (error) {
      console.error("Error fetching products:", error);
      throw error; // Allow the error to be caught by React Query
    }
  };

  // React Query to fetch products
  const queryProductKey = ["products", formId];
  const { data: products = [], isLoading, isError, error, refetch } = useQuery(
    queryProductKey,
    () => {
      // fetchProducts(formId)
    },
    {
      refetchOnWindowFocus: false,
    }
  );


  const formEditUrl = sale.form_type == 1 ? `/debit/edit/${formId}` : `/credit/edit/${formId}`;
  const goLiveFormatedDate = getFormatedDate(saleData.pd_go_live, "long");
  const createdFormDate = getFormatedDate(sale.created_at, "long");
  const updatedFormDate = getFormatedDate(sale.updated_at, "long");
  const createdProductDate = getFormatedDate(products.created_at, "long");
  const updatedProductsDate = getFormatedDate(products.updated_at, "long");
  const handleProjectDelete = () => {
    saleDeleteMutation.mutate(deleteableUser.form_id);
  };
  const handleAddProductsClick = (product) => {
    const route = product.product_type === 1
      ? `/cholder/debit/edit/${product.product_id}`
      : `/cholder/credit/edit/${product.product_id}`;
    console.log("product.form_id", product.form_id)
    navigate(route, { state: { formId: formId } });
  };

  useEffect(() => {
    function adjustWidth() {
      const bodyWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;

      setViewportWidth(bodyWidth);

      if (bodyWidth <= 767) {
        setVisibleSlides(1);
      } else if (bodyWidth <= 1200) {
        setVisibleSlides(2);
      } else {
        setVisibleSlides(3);
      }
    }

    // Call the function initially to set the initial number of visible slides
    adjustWidth();

    // Add event listener for window resize
    window.addEventListener("resize", adjustWidth);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", adjustWidth);
    };
  }, []);


  const isBase64 = (str) => {
    try {
      return btoa(atob(str)) === str;
    } catch (error) {
      return false;
    }
  };
  const getInitials = (name) => {
    // Split the name into words
    const words = name.split(" ");
    // Extract the first character of the first two words and convert them to uppercase
    const initials = words
      .slice(0, 2)
      .map((word) => word.charAt(0).toUpperCase());
    // Concatenate the initials
    return initials.join("");
  };
  const {
    data: user,
    refetch: refetchUserProfile,
    remove,
  } = useQuery("userProfile", () => UserManagmentService.getUserProfile(), {
    staleTime: 300000,
  });
  const profileData = user?.data?.data?.user;
  useEffect(() => {
    localStorage.setItem("role", profileData?.role_name ?? "");
  }, [user]);

  const assignProject = useMutation({
    mutationFn: async (payload) => {
      return await FormsService.assignFormsToUser(
        formId,
        payload?.userIds ?? [],
      );
    },
    onSuccess: (data) => {
      // if(data.data.status == false){
      //   setReloadComponent(true);
      //   onAssignSuccess();
      // }
      // setReloadComponent(true);
      // onAssignSuccess();
      queryClient.invalidateQueries(queryKey);
      onDeleteSuccess();
    },
    onError: (e) => {
      console.log("api error");
    },
  });

  const handleAssignProjectsToUser = async (selectedRows) => {
    try {
      const userIds = selectedRows.map((row) => row.user_id);
      const payload = {
        formId,
        userIds,
      };
      await assignProject.mutate(payload);
    } catch (error) {
      console.log(error);
    } finally {
      setOpenUserModal(false);
    }
  };
  const clientUser = profileData?.role_name === "client";
  const viewOnlyUser = profileData?.role_name === "viewonly";
  const generatePdf = async (e, type) => {
    try {
      setLoading(true);
      const response = await SalesService.pdfGeneration(formId, type);
      const pdfBlob = new Blob([response.data], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfUrl);
      return console.log(response);
    } catch (error) {
      // Handle error
      console.error("Error:", error);
      return false;
    } finally {
      setLoading(false);
    }
  };

  const adminUser = profileData?.role_name === "admin";
  const superAdminUser = profileData?.role_name === "super_admin";
  return (
    <React.Fragment>
      {loading && <OverlayLoader />}
      <ConfirmaionModal
        key={sale.id}
        open={showConfirmatonModal}
        setOpen={() => setShowConfirmatonModal(false)}
        title={"Delete Record"}
        headerArt={"cs-linear-alert-circle"}
        message={"Are you sure you want to delete the Sale?"}
        variant="danger"
        layout={"layoutCenter"}
        cancelButtonText={"Cancel"}
        confirmButtonText={"Delete"}
        confirmBtnVariant={"primary"}
        handleConfirmation={handleProjectDelete}
        disableConfirmBtn={saleDeleteMutation.isLoading}
        disableCancelBtn={saleDeleteMutation.isLoading}
      />
      <>

        <div className="single-sale-parent">
          <div className="single-sale-inner1" >
            <div className="single-sale-inner1-child1 "
            // onClick={() => setShowDetails(!showDetails)}
            >
              <div className="single-detail-container">
                <div className="single-sale-name">
                  <div>{saleData?.pi_program_name}</div>
                  <div>
                    <I2cBadge
                      // onClick={() => setShowDetails(!showDetails)}
                      className="single-sale-type"
                      size="small"
                      variant={`light-${badgeVariant}`}
                    >
                      {statuses[sale.form_status_id - 1]}
                    </I2cBadge>
                  </div>
                </div>
                <div className="single-sale-detail">
                  <div className="single-sale-detail-owner-name">
                    By {sale?.added_by_name ?? ""}
                  </div>
                  <div className="single-sale-detail-date">
                    <I2cFormatDate
                      month="short"
                      day="numeric"
                      year="numeric"
                      date={createdFormDate.date}
                    />{" "}
                    - {createdFormDate.time}
                  </div>
                </div>
              </div>
            </div>
            <div className="single-sale-inner1-child2">
              <div className="child1-avatar-containerr">
                <ErrorBoundary>
                  <Suspense
                    fallback={
                      <I2cAvatar
                        size="medium"
                        shape="circle"
                        label="Circle avatar"
                      />
                    }
                  >
                    <LazyComponent assignedAvatars={assignedAvatars ?? []} />
                  </Suspense>
                </ErrorBoundary>
                {!clientUser && !viewOnlyUser &&
                  assignedAvatars.length < 2 &&
                  statuses[sale.form_status_id - 1] != "Draft" && (
                    <>
                      <I2cButton
                        variant="secondary gray"
                        onlyicon
                        circle
                        size="x-small"
                        className="dashed-button"
                        onClick={() => setOpenUserModal(true)}
                      >
                        <I2cIcon name="cs-linear-plus" />
                      </I2cButton>
                      <I2cDialog
                        className="unclosable overlay custom-dialog"
                        label="Assign Users"
                        headerArt=""
                        headerArtStyle=""
                        style={{
                          "--width":
                            "calc(var(--i2c-spacing-64) * 2 + var(--i2c-spacing-32) + var(--i2c-spacing-2-5))",
                        }}
                        variant="primary"
                        uncloseableOverlay={true}
                        open={openUserModal}
                        onI2cHide={(event) => {
                          if (event.target.tagName === "I2C-DIALOG")
                            setOpenUserModal(false);
                        }}
                        closable
                      >
                        <AssignProjectUsers
                          closeModal={() => setOpenUserModal(false)}
                          userTableDataApi={table}
                          userTableDataApiExternal={tableExternal}
                        // onAssignSuccess={handleAssignSuccess}
                        />
                        <footer slot="footer">
                          <I2cButton
                            slot="footer"
                            variant="secondary gray"
                            onClick={() => setOpenUserModal(false)}
                          >
                            Cancel
                          </I2cButton>
                          <I2cButton
                            slot="footer"
                            variant="primary"
                            onClick={() => {
                              const api = table.current.getGridApi();
                              const apiExternal =
                                tableExternal.current.getGridApi();
                              const selectedNodesInternal =
                                api.getSelectedNodes();
                              const selectedNodesExternal =
                                apiExternal.getSelectedNodes();
                              const mergedNodes = [
                                ...selectedNodesInternal,
                                ...selectedNodesExternal,
                              ];
                              const selectedRows = mergedNodes.map(
                                (node) => node.data,
                              );
                              handleAssignProjectsToUser(selectedRows);
                            }}
                          >
                            Assign
                          </I2cButton>
                        </footer>
                      </I2cDialog>
                    </>
                  )}
              </div>
              <div className="btn-flex">
                {!viewOnlyUser && (
                  <I2cButton
                    onClick={() => navigate(formEditUrl)}
                    variant="secondary gray"
                    size="x-small"
                  >
                    <I2cIcon name="linear-edit-2" size="x-small" />
                  </I2cButton>
                )}

                <I2cDropdown
                  distance="10"
                  placement="bottom-end"
                  width="calc(var(--i2c-spacing-40) + var(--i2c-spacing-0.5))"
                  stayOpenOnSelect={false}
                >
                  <I2cButton
                    slot="trigger"
                    variant="secondary gray"
                    size="x-small"
                  >
                    <I2cIcon name="cs-linear-dots-vertical" />
                  </I2cButton>
                  <I2cMenu className="add-new-project-menu">
                    <I2cMenuItem
                      size="small"
                      onClick={() => {
                        if (sale.form_type == 1)
                          navigate(`/debit/view/${formId}`);
                        else navigate(`/credit/view/${formId}`);
                      }}
                      className="add-project-menu-item"
                    >
                      <span>Review</span>
                      <I2cIcon slot="prefix" name="cs-linear-layers-two" />
                    </I2cMenuItem>
                    {sale.form_status_id > 1 ? (
                      <I2cMenuItem
                        size="small"
                        onClick={() =>
                          generatePdf(
                            formId,
                            sale.form_type == 1 ? "prepaid" : "credit",
                          )
                        }
                        className="add-project-menu-item"
                      >
                        <span>Download</span>
                        <I2cIcon
                          slot="prefix"
                          name="linear-document-download"
                        />
                      </I2cMenuItem>
                    ) : (
                      ""
                    )}

                    {(superAdminUser || adminUser) && (
                      <I2cMenuItem
                        size="small"
                        onClick={() => {
                          setDeleteableUser(sale);
                          setShowConfirmatonModal(true);
                        }}
                        className="add-project-menu-item red"
                      >
                        <span>Delete</span>
                        <I2cIcon slot="prefix" name="linear-trash" />
                      </I2cMenuItem>
                    )}
                  </I2cMenu>
                </I2cDropdown>
              </div>
            </div>
          </div>
          <div className="single-sale-inner2" onClick={() => setShowDetails(!showDetails)}>
            <div className="single-sale-inner2-child">
              <div className="child-header">Program Type</div>
              <div className="child-value">
                {sale.form_type == 1 ? "Prepaid/Debit" : "Credit"}
              </div>
            </div>
            <div className="single-sale-inner2-child">
              <div className="child-header">Region</div>
              <div className="child-value">
                {/* <I2cIcon
									name='outline-edit-2'
									color='black'
									variant='default'
									slot='prefix'
								/> */}
                {saleData.pd_region ?? "-"}
              </div>
            </div>
            <div className="single-sale-inner2-child">
              <div className="child-header">Target Go Live Date</div>
              <div className="child-value">
                {goLiveFormatedDate.date ?? "-"}
              </div>
            </div>
            <div className="single-sale-inner2-child">
              <div className="child-header">Bank</div>
              <div className="child-value">
                {saleData.ci_businessName ?? "-"}
              </div>
            </div>
            <div className="single-sale-inner2-child">
              <div className="child-header">Phone Number</div>
              <div className="child-value">
                {saleData.ci_companyPhone ?? "-"}
              </div>
            </div>
          </div>
          <div className="single-user-inner1-child2-mobile">
            {!viewOnlyUser && (
              <I2cButton
                onClick={() => navigate(formEditUrl)}
                variant="secondary"
                size="medium"
              >
                <I2cIcon
                  name="linear-edit-2"
                  color="white"
                  variant="default"
                />
                <span className="icons-text">Edit</span>
              </I2cButton>
            )}

            <I2cDropdown
              distance="10"
              placement="bottom-end"
              width="100%"
              className="more-btn-mob"
              stayOpenOnSelect={false}
            >
              <I2cButton slot="trigger" variant="secondary gray" size="medium">
                <I2cIcon name="linear-more" />
                <span className="icons-text">More</span>
              </I2cButton>
              <I2cMenu className="add-new-project-menu">
                <I2cMenuItem
                  size="small"
                  onClick={() => {
                    if (sale.form_type == 1) navigate(`/debit/view/${formId}`);
                    else navigate(`/credit/view/${formId}`);
                  }}
                  className="add-project-menu-item"
                >
                  <span>Review</span>
                  <I2cIcon slot="prefix" name="cs-linear-layers-two" />
                </I2cMenuItem>
                {/* <I2cMenuItem
                  size="small"
                  onClick={() => generatePdf(formId)}
                  className="add-project-menu-item"
                >
                  <span>Download</span>
                  <I2cIcon slot="prefix" name="linear-document-download" />
                </I2cMenuItem> */}
                {(superAdminUser || adminUser) && (
                  <I2cMenuItem
                    size="small"
                    onClick={() => {
                      setDeleteableUser(sale);
                      setShowConfirmatonModal(true);
                    }}
                    className="add-project-menu-item red"
                  >
                    <span>Delete</span>
                    <I2cIcon slot="prefix" name="linear-trash" />
                  </I2cMenuItem>
                )}
              </I2cMenu>
            </I2cDropdown>
          </div>
        </div>

        {(showDetails && showProducts) && (
          <>
            <hr className="single-sale-break-line" />
            <div className="single-sale-detail-section">
              <div className="single-sale-detail-section-header">
                <span className="single-sale-detail-section-header-title">
                  Consumer Channels
                </span>
                <I2cButton
                  size="x-small"
                  className="single-sale-detail-section-header-button"
                  variant="link color"
                  onClick={() => {
                    const path =
                      sale.form_type === 1
                        ? `/debit/edit/${formId}`
                        : `/credit/edit/${formId}`;

                    navigate(path, { state: { isAddProduct: true } });
                  }}
                >
                  <I2cIcon
                    className="single-sale-detail-section-header-button-icon"
                    name="linear-add"
                  />
                  <span>Add Products</span>
                </I2cButton>
              </div>
              <div
                style={{
                  // height: "calc(var(--i2c-spacing-64) - 5px)",
                  textAlign: "center",
                }}
              >

                <CarouselProvider
                  naturalSlideWidth={328}
                  naturalSlideHeight={192}
                  infinite
                  visibleSlides={visibleSlides}
                  totalSlides={products.length}
                >
                  <Slider >
                    {products.map((channel, index) =>
                      <Slide className="slide-spacer" index={index} key={`${index}`}>
                        <div className={`carousel-card-container ${channel.validation_states === null ? 'carousel-background-brand' : 'carousel-background-warning'}`}>
                          <div className="carousel-card-title">
                            {getLabel(channelsText.consumer, channel.product_name)}
                          </div>
                          <div className="carousel-card-sub-title">
                            <I2cFormatDate
                              month="short"
                              day="numeric"
                              year="numeric"
                              date={channel.updated_at ?? "-"}
                            />{" "}
                            -  {getFormatedDate(channel.updated_at, "long").time ?? "-"}

                          </div>
                          <I2cProgressBar
                            value="65"
                            valPosition="front"
                            className="carousel-card-progress"
                          ></I2cProgressBar>
                          <div className="carousel-card-body-button">
                            <I2cButton
                              size="x-small"
                              className=""
                              variant="link gray"
                              onClick={() => handleAddProductsClick(channel)}
                            >
                              <span className="carousel-card-body-button-text blue-color">
                                {
                                  channel.validation_states === null ? "Start" : "Continue"
                                }
                              </span>
                              <I2cIcon
                                className="carousel-card-body-button-icon blue-color"
                                name="linear-arrow-right"
                              />
                            </I2cButton>
                          </div>
                        </div>
                      </Slide>
                    )}
                  </Slider>

                </CarouselProvider>
              </div>
            </div>
          </>
        )}
      </>
    </React.Fragment>
  );
};

export default SingleSalePreview;
